var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-button',{class:_vm.$style.container,attrs:{"size":"md","is-loading":_vm.isLoading},on:{"click":_vm.checkClientName}},[_c('icon',{attrs:{"name":"comment","width":"14","height":"12"}}),_c('v-count',{key:_vm.post.comment_count,attrs:{"count":_vm.post.comment_count}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }